export { default as Component } from "./CarouselItem.svelte";
export const modes = ["static"];
